module.exports = __webpack_public_path__ + "img/cat tunnel.ed902f2c.png";